import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Card } from "primereact/card";
import { classNames } from "primereact/utils";

import "./AddFeatureTile.scss";

import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { translationKeys } from "../../../../../models/app-translation-keys";

interface IAddFeatureTileProps {
  disabled?: boolean;
  onClick: () => void;
}
const featureKeys = translationKeys.adminArea.featureTiles;

export const AddFeatureTile: FunctionComponent<IAddFeatureTileProps> = ({ disabled, onClick }) => {
  const { t } = useTranslation();

  return (
    <Card
      className={classNames("admin-feature-card--add", { disabled: !!disabled })}
      onClick={() => !disabled && onClick()}
    >
      <div className="admin-feature-card-add-content">
        <label htmlFor="browse" className="add-icon-container">
          <div className="add-icon">
            <FontAwesomeIcon icon={faPlus} />
          </div>
        </label>

        <div className="admin-feature-card-add-title">{t(featureKeys.actions.create.name)}</div>
      </div>
    </Card>
  );
};
